module.exports = __webpack_public_path__ + "img/wz-8-4-1.64edd261.jpg";